module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-37.cfd4565a.jpg";